import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import * as Yup from 'yup';

import statuses from '../../../../data/policy_statuses';
import { useContext } from '../Context';

import EditModal from '../EditPolicy/EditModal';
import UnlockModal from '../EditPolicy/UnlockModal';

export default function Index() {
  const { dispatch, actions, state } = useContext();

  const [showModal, setShowModal] = useState(false);

  const replaceEmpty = (value) => (value == null || value == '' ? 'N/A' : value);

  const statusName = (status) => statuses.find((item) => item.value == status).label;

  const employeesCovered = (policy) => policy.attributes.employees_covered;

  return (
    <>
      <div className="ibox-content mt20">
        <Row>
          <Col md={6}>
            <h1>Policy</h1>
          </Col>
          <Col md={6} className="text-right">
            <h4>
              Payment Terms NET
              <span className="ml5">{state.policy.attributes.payment_terms}</span>
              <span className="ml5">/</span>
              <span className="ml5">Invoicing Day</span>
              <span className="ml5">
                {state.policy.attributes.invoicing_day}
              </span>
              <span className="ml5">/</span>
              <span className="ml5">Currency</span>
              <span className="ml5">
                {state.policy.attributes.currency_id === '' ? 'N/A' : state.policy.attributes.currency_title}
              </span>
            </h4>
          </Col>
        </Row>
        <div className="well">
          <Row>
            <Col className="text-center" md={3}>
              Policy number:
              {' '}
              {state.policy.attributes.number}
            </Col>
            <Col className="text-center" md={3}>
              Policy Effective Date:
              {' '}
              {replaceEmpty(
                state.policy.attributes.original_effective_date_formatted,
              )}
            </Col>
            <Col className="text-center" md={3}>
              <div>
                Policy Renewal Date:
                {' '}
                {replaceEmpty(state.policy.attributes.renewal_notification_date_formatted)}

              </div>
            </Col>
            {' '}
            <Col className="text-center" md={3}>
              Status:
              {' '}
              {statusName(state.policy.attributes.status)}
            </Col>
          </Row>
        </div>
        <div className="text-center mt40 mb40">
          <h2 className="green">{employeesCovered(state.policy)}</h2>
          <h2 className="green">Employees Covered</h2>
          {state.policy.attributes.is_lock
            && <p className="text-danger">{state.policy.attributes.lock_reason_human}</p>}
        </div>
        {state.policy.attributes.affiliates.length > 0 && (
          <div className="well">
            Affiliate(s):
            {state.policy.attributes.affiliates.map((item, index) => (
              <>
                {index > 0 ? ',' : ''}
                <span key={item.affiliate} className="ml5">
                  {item.name_with_commission}
                </span>
              </>
            ))}
          </div>
        )}

        <div className="text-right">
          <Button
            onClick={() => setShowModal(true)}
            bsClass="width-120 btn btn-green"
          >
            {state.policy.attributes.is_lock ? 'Unlock Policy' : 'Edit Policy'}
          </Button>
        </div>
      </div>
      {state.policy.attributes.is_lock
        ? <UnlockModal show={showModal} onHide={() => setShowModal(false)} />
        : <EditModal show={showModal} onHide={() => setShowModal(false)} />}

    </>
  );
}
